import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';

const initialState = fromJS({
    list: {
        isLoading: false,
        data: null
    },
    addOrEditModal: {
        isShown: false,
        isLoading: false,
        isEdit: false,
        record: null
    },
    ownerList: {
        isLoading: false,
        data: []
    },
    administration: {
        searchHomeFields: {
            searchMeterId: '',
            searchName: '',
            searchEmail: '',
            searchCompany: '',
        },
        searchUserFields: {
            searchName: '',
            searchEmail: '',
            searchCompany: '',
        },
        homes: {
            isLoading: false,
            data: null,
        },
        users: {
            isLoading: false,
            data: null,
            editUserModal: {
                isShown: false,
                isLoading: false
            }
        }
    },
    detail: {
        isLoading: false,
        data: null,
        addOrEditDeviceModal: {
            isShown: false,
            isLoading: false
        },
        meters: {
            isLoading: false,
            data: null,
            addOrEditModal: {
                isLoading: false
            }
        },
        switch: {
            isLoading: false,
            data: null,
            addOrEditModal: {
                isShown: false,
                isLoading: false
            }
        },
        users: {
            isLoading: false,
            data: null,
            invitedUsers: {
                isLoading: false,
                data: null
            },
            inviteModal: {
                isShown: false,
                isLoading: false
            }
        }
    }
});

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        // Homes
        case CONSTANTS.ON_HOMES_ARE_LOADING:
            return state.setIn(['list', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_HOMES_LIST:
            return state.setIn(['list', 'data'], payload.data);

        case CONSTANTS.ON_HOME_ADD_OR_EDIT_MODAL_IS_SHOWN:
            return state.setIn(['addOrEditModal', 'isShown'], payload.isShown);

        case CONSTANTS.ON_HOME_ADD_OR_EDIT_MODAL_IS_LOADING:
            return state.setIn(['addOrEditModal', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_HOME_ADD_OR_EDIT_MODAL_IS_EDIT:
            return state.setIn(['addOrEditModal', 'isEdit'], payload.isEdit);

        case CONSTANTS.ON_HOME_ADD_OR_EDIT_MODAL_SELECTED_ROW:
            return state.setIn(['addOrEditModal', 'record'], payload.record);

        // Administration
        case CONSTANTS.ON_ADMIN_HOMES_ARE_LOADING:
            return state.setIn(['administration', 'homes', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_ADMIN_HOMES_LIST:
            return state.setIn(['administration', 'homes', 'data'], payload.data);

        case CONSTANTS.ON_ADMIN_SEARCH_HOMES:
            return state.setIn(['administration', 'searchHomeFields'], payload.searchHomeFields);

        case CONSTANTS.ON_ADMIN_SEARCH_USERS:
            return state.setIn(['administration', 'searchUserFields'], payload.searchUserFields);

        case CONSTANTS.ON_ADMIN_USERS_ARE_LOADING:
            return state.setIn(['administration', 'users', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_ADMIN_USERS_LIST:
            return state.setIn(['administration', 'users', 'data'], payload.data);

        // Detail
        case CONSTANTS.ON_HOME_DETAIL_IS_LOADING:
            return state.setIn(['detail', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_HOME_DETAIL_DATA:
            return state.setIn(['detail', 'data'], payload.data);

        case CONSTANTS.ON_HOME_DETAIL_ADD_OR_EDIT_DEVICE_MODAL_IS_SHOWN:
            return state.setIn(['detail', 'addOrEditDeviceModal', 'isShown'], payload.isShown);

        case CONSTANTS.ON_HOME_DETAIL_ADD_OR_EDIT_DEVICE_MODAL_IS_LOADING:
            return state.setIn(['detail', 'addOrEditDeviceModal', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_HOME_DETAIL_METERS_IS_LOADING:
            return state.setIn(['detail', 'meters', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_HOME_DETAIL_METERS_DATA:
            return state.setIn(['detail', 'meters', 'data'], payload.data);

        case CONSTANTS.ON_HOME_DETAIL_METER_DEVICE_IS_LOADING:
            return state.setIn(
                ['detail', 'meters', 'data', payload.index, 'devices', 'isLoading'],
                payload.isLoading
            );
        case CONSTANTS.ON_HOME_DETAIL_METER_DEVICE_DATA:
            return state.setIn(
                ['detail', 'meters', 'data', payload.index, 'devices', 'data'],
                payload.data
            );

        case CONSTANTS.ON_HOME_DETAIL_METERS_ADD_OR_EDIT_MODAL_IS_SHOWN:
            return state.setIn(['detail', 'meters', 'addOrEditModal', 'isShown'], payload.isShown);

        case CONSTANTS.ON_HOME_DETAIL_METERS_ADD_OR_EDIT_MODAL_IS_LOADING:
            return state.setIn(['detail', 'meters', 'addOrEditModal', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_HOME_DETAIL_SWITCH_ADD_OR_EDIT_MODAL_IS_SHOWN:
            return state.setIn(['detail', 'switch', 'addOrEditModal', 'isShown'], payload.isShown);

        case CONSTANTS.ON_HOME_DETAIL_SWITCH_ADD_OR_EDIT_MODAL_IS_LOADING:
            return state.setIn(['detail', 'switch', 'addOrEditModal', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_HOME_USER_LIST_IS_LOADING:
            return state.setIn(['detail', 'users', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_HOME_USER_LIST_DATA:
            return state.setIn(['detail', 'users', 'data'], payload.data);

        case CONSTANTS.ON_HOME_INVITE_RESIDENT_MODAL_IS_SHOWN:
            return state.setIn(['detail', 'users', 'inviteModal', 'isShown'], payload.isShown);

        case CONSTANTS.ON_HOME_INVITE_RESIDENT_MODAL_IS_LOADING:
            return state.setIn(['detail', 'users', 'inviteModal', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_HOME_DETAIL_INVITED_USERS_LIST:
            return state.setIn(['detail', 'users', 'invitedUsers', 'data'], payload.data);

        case CONSTANTS.ON_HOME_DETAIL_INVITED_USERS_IS_LOADING:
            return state.setIn(['detail', 'users', 'invitedUsers', 'isLoading'], payload.isLoading);

        // Owner list
        case CONSTANTS.ON_OWNER_LIST_IS_LOADING:
            return state.setIn(['ownerList', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_OWNER_LIST_DATA:
            return state.setIn(['ownerList', 'data'], payload.data);

        default:
            return state;
    }
};

export default reducer;
